module.exports = __webpack_public_path__ + "static/media/template_task.120a8925.csv";